import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const getUserProfileDetails = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.getUserProfile, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateUserProfile = async (profile: any) => {
  try {
    const callParams = await getCallParams("PUT", profile);
    const response = await makeCall(urls.updateUserProfile, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
